import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import { Observable } from "rxjs";
import { normalize, schema } from "normalizr";
import * as data from "../data/languages.json";
import { push } from "connected-react-router";

export const getLanguagesEpic = (action$, store) =>
  action$.ofType(actionTypes.GET_LANGUAGES).switchMap(action => {
    return Observable.ajax({
      crossDomain: true,
      url: `https://swapi.co/api/people/20`
    })
      .map(({ response }) => {
        const payload = normalizeLanguages(response);
        return actions.getLanguagesSuccess(payload);
      })
      .catch(error => Observable.of(actions.getLanguagesError(error.message)));
  });

export const setBrowserLanguageEpic = (action$, store) =>
  action$.ofType(actionTypes.GET_LANGUAGES_SUCCESS).mergeMap(action => {
    const state = store.getState().language;
    const { entities } = state;
    const { browserLanguageId } = state;
    const language =
      entities.byId[browserLanguageId] || entities.byId[entities.all[0]];
    return Observable.of(actions.selectLanguage(language));
  });

export const setLanguageEpic = (action$, store) =>
  action$.ofType(actionTypes.SELECT_LANGUAGE).switchMap(action => {
    const state = store.getState().auth;
    const { user } = state;
    if (user) {
      // if the user is logged in, we reset all the states and go to the home page, we use Observable.of to dispach multiple actions
      return Observable.of(push("/home"), actions.getMainFilters());
    } else {
      return Observable.empty();
    }
  });

const normalizeLanguages = response => {
  const _language = new schema.Entity("languages", {}, { idAttribute: "id" });
  const mySchema = [_language];

  const normalizedData = normalize(data, mySchema);
  const { result, entities } = normalizedData;
  return {
    all: result,
    byId: entities.languages
  };
};



// WEBPACK FOOTER //
// ./src/epics/language.js